"use client";
import React, { useCallback, useEffect } from "react";
import { useProductDetailsContext } from "@/src/provider/ProductDetails/context";
import { CURRENCY_COOKIE_NAME } from "@/config/constConf";
import { getCookieItem } from "@/lib/commonService";
import criteoAd from "@/src/components/LoadAnalysis/analysis/criteo";
import newTiktokPixel from "@/src/components/LoadAnalysis/analysis/newTiktokPixel";
import reddit from "@/src/components/LoadAnalysis/analysis/reddit";
import { getSite } from "@/src/utils/configUtils";
import useAnalysis from "@/src/hooks/useAnalysis";
import useBrowserGoodsDetailGA from "@/src/hooks/useBrowserGoodsDetailGA";

// 需要在客户端进行初始化的使用这个组件
const ProductDetailInit: React.FC = () => {
    const { facebookPixel, GoogleAnalytics } = useAnalysis();
    const activeObj = useProductDetailsContext((state) => state.activeObj);
    const browserGoodsDetailGA = useBrowserGoodsDetailGA();
    /**
     * 用于商品详情页的浏览事件
     */
    const viewContentEvent = useCallback(() => {
        const { onsale, products_id } = activeObj;
        if (!onsale || !products_id) return;
        const host = self.location.host;
        const site = getSite(host);
        const content_id =
            site === "uk" ? products_id + "-" + activeObj.id : products_id; // activeObj.id即为color_id
        const content_type = "product";
        const currency = getCookieItem(CURRENCY_COOKIE_NAME) || "USD";

        facebookPixel({
            trackPage: "ViewContent",
            trackPageContent: {
                content_ids: [content_id], //产品id 数组
                content_type, // "product"
                price: onsale?.price, //产品价格 不带货币单位
                currency, //价格货币单位
            },
        });

        criteoAd.viewItem(activeObj.id);

        GoogleAnalytics(
            {
                ecomm_prodid: products_id, //产品ID//填充
                ecomm_pagetype: content_type,
                ecomm_totalvalue: Number(onsale?.price), //产品价格//填充
            },
            browserGoodsDetailGA,
        );

        reddit.ViewContent();

        newTiktokPixel.ViewContent(
            {
                content_type: "product",
                contents: [
                    {
                        quantity: 1,
                        content_id: `${products_id}`,
                        price: onsale?.price,
                    },
                ],
                currency: self.process.env.CURRENCY,
                value: onsale?.price,
            },
            products_id,
        );
    }, [GoogleAnalytics, activeObj, browserGoodsDetailGA, facebookPixel]);

    useEffect(() => {
        viewContentEvent();
    }, [viewContentEvent]);

    return <></>;
};

export default ProductDetailInit;
